import { useEffect } from "react";
import { Form, Descriptions } from "antd";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { ERROR_MSGS, BTN_TXT } from "../../../../constants/constants";
import FormFooter from "../../../../components/CustomForms/FormFooter";
import ErrorAlert from "../../../../components/ErrorAlert/ErrorAlert";
import { useSelector, useDispatch } from "react-redux";
import { ReAssignToRm, getRmData, RMtableDetailView } from "../../../../redux/slices/rmSlice";

const ReassignRmForm = ({ onClose, reassignUser, rm }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { assignRmLoading, error, rmTabledata } = useSelector((state) => state.rm);

    useEffect(() => {
        const isInvestor = reassignUser?.Business?.isInvestor;
        const payload = {
            usersUnderRmList: false,
            ...(isInvestor === true && { forInvestor: true }),
            ...(isInvestor === false && { forBusiness: true }),
        };
        if ('forInvestor' in payload || 'forBusiness' in payload) {
            dispatch(getRmData(payload));
        }
    }, [dispatch, reassignUser?.Business?.isInvestor]);

    const handleAssignRm = async (values) => {
        const payload = {
            rmUserId: values.rm,
            assigneeUserId: [reassignUser.userId]
        };
        const result = await dispatch(ReAssignToRm(payload))
        if (result.payload.statusCode === 201) {
            dispatch(RMtableDetailView(rm.userId));
            onClose()
        }
    }

    const userDetailsItems = [
        { key: "userName", label: "User Name", children: reassignUser?.userName },
        { key: "org", label: "Organization", children: reassignUser?.orgName },
    ];

    return (
        <div className="re-assign-rm-form-container">
            <Descriptions
                bordered
                column={1}
                items={userDetailsItems}
                style={{ marginBottom: 20 }}
            />
            <Form layout="vertical" form={form} onFinish={handleAssignRm}>

                <CustomSelect
                    name="rm"
                    label="Select RM"
                    placeholder="Select RM"
                    isRequired={true}
                    rules={[{ required: true, message: ERROR_MSGS.SEL_RM_ERR_MSG }]}
                    options={rmTabledata?.map((user) => ({
                        value: user.userId,
                        label: user.userName,
                    }))}
                />

                {error && (
                    <ErrorAlert error={error} />
                )}

                <FormFooter
                    onCancelClick={() => {
                        onClose();
                        form.resetFields();
                    }}
                    submitLoading={assignRmLoading}
                    btnName={BTN_TXT.RE_ASSIGN}
                />
            </Form>
        </div>
    )
}

export default ReassignRmForm